import React from 'react';
import { LoaderAnimation } from 'src/components';

export function Loader() {
  return (
    <div className=" fixed inset-0 bg-gray-600 overflow-y-auto flex items-center justify-center h-full w-full">
      <LoaderAnimation width={125} height={125} />
    </div>
  );
}
